import LegalPage from './LegalPage';
import { TERMS_META, TERMS_SECTIONS } from './termsContent';

export default function TermsPage() {
  return <LegalPage {...TERMS_META} sections={TERMS_SECTIONS} />;
}
